<template>
<div>
<h1>Test webpay</h1>

<HotelDatePicker :disabledDates="['2019-11-14', '2019-10-15' ]"></HotelDatePicker>


<a :href="url">pagar</a>

</div>
</template>
 
<script>
import axios from 'axios'
import HotelDatePicker from 'vue-hotel-datepicker'
export default {
    data: function () {
        return {
            url: process.env.VUE_APP_API_URL+'webpay/pay'
        }
    },
  components: {
    HotelDatePicker,
  },    
}
</script> 

